export default "__VITE_ASSET__aGxB62N___"